// plugins/global-components.js
import { defineNuxtPlugin } from '#app';
import Frame from '~/components/ui/frame.vue'; // Adjust the path if needed
import Handler from '~/components/ui/handler.vue'; // Adjust the path if needed

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.component('Frame', Frame);
  nuxtApp.vueApp.component('Handler', Handler);
});
